import { render, staticRenderFns } from "./ContentSocial.vue?vue&type=template&id=190c4902&scoped=true&"
import script from "./ContentSocial.vue?vue&type=script&lang=js&"
export * from "./ContentSocial.vue?vue&type=script&lang=js&"
import style0 from "./ContentSocial.vue?vue&type=style&index=0&id=190c4902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190c4902",
  null
  
)

export default component.exports